import { Component, OnDestroy, OnInit } from '@angular/core';
import { AlertContextEnum } from '../../../../../../modules/src/lib/core/enums/alert-context.enum';
import {
  ClientQuestionnaireModel,
} from '../../../../../../../../common/dist/angular/models/client-questionnaire.model';
import {
  ClientQuestionnairesApiController,
} from '../../../../../../modules/src/lib/questionnaires/api-controllers/client-questionnaires.api-controller';
import {
  ClientQuestionnaireStore,
} from '../../../../../../modules/src/lib/questionnaires/stores/client-questionnaire.store';
import { ActivatedRoute, Router } from '@angular/router';
import { DateUtils } from '../../../../../../modules/src/lib/core/utils/date.utils';

@Component({
  selector: 'app-list-client-questionnaires',
  templateUrl: './list-client-questionnaires.component.html',
  styleUrls: ['./list-client-questionnaires.component.scss'],
  standalone: false,
})
export class ListClientQuestionnairesComponent implements OnInit, OnDestroy {
  alertContextEnum = AlertContextEnum;

  isLoading = true;
  showHasBeenRefreshed = true;

  clientQuestionnaires: ClientQuestionnaireModel[];

  constructor(private readonly apiController: ClientQuestionnairesApiController,
              private readonly dateUtils: DateUtils,
              private readonly router: Router,
              private readonly route: ActivatedRoute,
              private readonly clientQuestionnaireStore: ClientQuestionnaireStore) {
  }

  ngOnDestroy(): void {
  }

  async ngOnInit(): Promise<void> {
    await this.refresh();
  }

  async refresh(): Promise<void> {
    this.isLoading = true;
    this.showHasBeenRefreshed = false;

    this.clientQuestionnaires = await this.apiController.list();
    for (const clientQuestionnaire of this.clientQuestionnaires) {
      await this.clientQuestionnaireStore.save(clientQuestionnaire.id, clientQuestionnaire);
    }

    this.isLoading = false;
    this.showHasBeenRefreshed = true;

    setTimeout(() => {
      this.showHasBeenRefreshed = false;
    }, 3000);
  }

}
